module.exports = require('./helpers/bundle-url').getBundleURL('aDgzp') + "logo-dark.eefe0b7f.svg";